<template>
  <div class="inputContainer form-group mb-2 ">
    <input
        v-bind="$attrs"
        :type="isNumber ? 'tel':'text'"
        :class="{
          'choice':true,
          'quill-question-input':true,
          'form-control': true,
          'invalid': isInvalid,
          'adjust': inputValue,
          }"
        :disabled="(question.status?.toLowerCase() !== 'editable')"
        :id="question.name"
        :name="question.name"
        v-model="inputValue"
        :aria-describedby="`${question.name}_describedby`"
        @input="disableConfirm ? emitChange(): validateInput()"
        @blur="emitChange"
        @keydown.tab="emitChange"
        @keydown.enter.prevent.stop="emitChange">
    <span class="quill-question-placeholder">
      {{ forcePromptPlaceholder ? question.prompt : (question.placeholder || question.prompt) }}
    </span>

  </div>
  <div class="flex-column">
    <div class="subtext errorMessage d-block pt-1" v-html="isInvalid"></div>
    <div class="align-text-end" v-if="!disableConfirm && inputValue && !isInvalid" role="button" @click.stop="emitChange">Confirm</div>
  </div>
</template>
<script>
export default {
  name: "InputText",
  data() {
    return {
      inputValue: '',
      isInvalid: null,
    }
  },
  mounted() {
    this.inputValue = this.question.value;

    if (!this.skipEagerValidation) {
      this.validateInput()
    }
    if (this.question.error) {
      this.isInvalid = this.question.error
      this.$emit('field-error', true)
    }
  },
  computed: {
    frontendCriteria() {
      return this.question.criteria.find(el => typeof el === 'object')
    }
  },
  watch: {
    question: {
      handler(newQuestion) {
        if (newQuestion.value) {
          this.inputValue = newQuestion.value
          return this.validateInput(newQuestion.error)
        }
        if(newQuestion.error){
          this.isInvalid = newQuestion.error
          this.$emit('field-error', true)
        }
      },
      deep: true,
    }
  },
  methods: {
    restrictToNumbers() {
      if (this.isNumber) {
        this.inputValue = this.inputValue?.replace(/[^0-9]/g, "") ?? '';
      }
      if (this.frontendCriteria?.restriction) {
        const regex = new RegExp(this.frontendCriteria.restriction,'g')
        this.inputValue = this.inputValue?.replace(regex, "") ?? '';
      }
    },
    emitChange() {
      if (this.inputValue) {
        this.inputValue = this.inputValue?.trim()
      }
      if (this.validateInput()) {
        this.$emit('update:modelValue', this.inputValue)
        if(this.question.value){
                    this.$emit('confirm')
        }
      }
    },
    validateInput(errorMsg) {
      this.restrictToNumbers()
      const val = this.inputValue
      if (this.question && this.question.required) {
        if (!val || errorMsg) {
          this.isInvalid = errorMsg || 'Required'
          this.$emit('field-error', true)
          return false
        } else {
          this.isInvalid = null
          this.$emit('field-error', false)
        }
      }

      if (this.question && this.question.criteria) {

        if (this.isNumber && this.frontendCriteria?.min_value && Number(val) < this.frontendCriteria?.min_value) {
          this.isInvalid = `Value cannot be less than ${this.frontendCriteria?.min_value}`
          this.$emit('field-error', true)
          return false
        }

        if (this.isNumber && this.frontendCriteria?.max_value && Number(val) > this.frontendCriteria?.max_value) {
          this.isInvalid = `Value cannot be more than ${this.frontendCriteria?.max_value}`
          this.$emit('field-error', true)
          return false
        }

        if (this.frontendCriteria && this.frontendCriteria.regex) {

          const regex = new RegExp(this.frontendCriteria.regex)
          if (!regex.test(val)) {
            this.isInvalid = `Invalid entry`
            this.$emit('field-error', true)
            return false
          } else {
            this.isInvalid = null
            this.$emit('field-error', false)
          }
        }
      }
      return true
    }
  },
  props: [
    'modelValue',
    'question',
    'hideSubText',
    'forcePromptPlaceholder',
    'skipEagerValidation',
    'isNumber',
    'disableConfirm'
  ],
  emits: ['update:modelValue', 'field-error','confirm'],
}
//TODO:CLEAN UP AND REFINE CSS
</script>
<style scoped lang="scss">
.align-text-end {
  text-align: end;
}

.subtext {
  font-size: .75rem;
  font: normal normal normal 12px/18px Roboto;
  letter-spacing: 0px;
  margin-bottom: 4px;
  color: #757575
}

.errorMessage {
  color: #BB0000
}

.gap {
  margin-right: 10px;
}

.quill-question {

  > div.inputContainer {
    position: relative;
    min-height: 50px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    cursor: pointer;

    > .quill-question-input {
      box-sizing: border-box;
      border: 1px solid #ccc;
      border-radius: 3px;
      padding: 16px 5px;
      width: 100%;
      font-size: 16px;
      font-weight: bold;
      background: transparent;
      min-height: 100%;
      @media screen and (max-width: 768px) {
        min-width: auto !important;
        // flex: 0 0 45% !important;
      }

      &:has(~.question-type-unknown) {
        border-color: #BB0000;
      }

      &:hover, &:focus {
        border: 2px solid #212121;
        box-shadow: none;
        padding: 15px 5px;
      }

      &:disabled {
        background-color: #EEEEEE;
      }
    }

    .quill-question-placeholder {
      position: absolute;
      padding: 14px 16px;
      line-height: 2em;
      top: 0;
      left: 0;
      color: #757575;
      font-size: 16px;
      pointer-events: none;
      transform: scale(1);
      transition: .26s all ease;
    }
  }
}

/*TODO convert to scss*/


.quill-question > div.inputContainer .quill-question-input:focus,
.quill-question > div.inputContainer .quill-question-input:not(.radio,:placeholder-shown) {
  padding: 25px 8px 5px 16px;
}

.quill-question > div.inputContainer .quill-question-input:focus + .quill-question-placeholder {
  font-size: 12px;
  padding: 8px 8px 5px 16px;
}

.adjust + .quill-question-placeholder {
  font-size: 12px !important;
  padding: 6px 8px 5px 16px !important;
}


.form-floating > .form-control:focus ~ label.form-label-text, .form-floating > .form-control:focus ~ label {
  font-size: 12px;
  color: #484848;
  padding-top: 1rem;
}

.form-control-disabled:hover {
  border: none;
}

.form-control-enabled:hover {
  border: 2px solid #212121
}

.invalid {
  border: 1px solid #BB0000 !important;

  &:hover, &:focus, &:focus-within {
    border: 2px solid #BB0000 !important;
  }
}

</style>